// user.facade.ts
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { UserModel } from '../../../models/vet-users/user.model';
import * as userActions from './user.action';
import * as userSelectors from './user.selector';

@Injectable({
  providedIn: 'root',
})
export class UserFacade {
  users$: Observable<UserModel[]> = this.store.select(userSelectors.selectUsers);
  usersLoading$: Observable<boolean> = this.store.select(userSelectors.selectUsersLoading);
  usersError$: Observable<any> = this.store.select(userSelectors.selectUsersError);
  success$: Observable<any> = this.store.select(userSelectors.selectSuccess);
  user$: Observable<UserModel | null> = this.store.select(userSelectors.selectUser);
  constructor(private store: Store) { }

  loadUsers(): void {
    this.store.dispatch(userActions.loadUsers());
  }

  saveUser(user: UserModel): void {
    this.store.dispatch(userActions.saveUser({ user }));
  }
  forgotPasswordByUserId(userId: number): void {
    this.store.dispatch(userActions.forgotPasswordByUserId({ userId }));
  }
  getUser(userId: number): void {
    this.store.dispatch(userActions.getUser({ userId }));
  }
}
